//  https:// vue-i18n.intlify.dev/guide/essentials/started.html

export default {
  welcomeLogin: "", //  en.ts无注释
  operate: "操作",
  serialNum: "序号",
  departStation: "上站",
  getOffTheStation1: "下站",
  getOnTheStation: "上站点",
  getOffTheStation: "下站点",
  departTime: "发车时间",
  seatNum: "座位",
  wayType: "往返类型",
  ticketCategory: "票种",
  ticketFaceVal: "票价",
  type: "类型",
  name: "姓名",
  areaCd: "区号",
  tel: "联系方式",
  idType: "证件类型",
  idNo: "证件号码",
  noData: "暂无数据",
  schedulePrice: "新票售价",
  priceDiff: "补差价",
  chineseMain: "大陆",
  hongKong: "香港",
  macao: "澳门",
  bigVehicle: "大巴",
  smallVehicle: "小车",
  oneWay: "单程",
  priceRules: "价格规则",
  roundTrip: "往返",
  departureCity: "出发城市",
  departure: "出发",
  arrival: "到达",
  destinationCity: "到达城市",
  departureDate: "出发日期",
  returnDate: "返程日期",
  selectDate: "选择日期",
  passengersAmount: "乘客人数",
  inquiry: "查询",
  save: "保存",
  add: "新增",
  export: "导出",
  advancedSearchAction: "高级搜索",
  totalNumberTickets: "购票总张数",
  totalAmountTicket: "购票总金额",
  currency: "币种",
  departTrip: "去程",
  returnTrip: "返程",
  purchaseQuantity: "购买数量",
  number: "数量",
  scheduleInfo: "班次信息",
  selectSeat: "选座",
  copyDownward: "向下复制",
  refresh: "刷新",
  unlockOcc: "解除锁位",
  isLocks: "是否解除所有锁位",
  balance: "账户余额",
  dateOfUse: "使用日期",
  ticketSection: "票段",
  purchasePayAcc: "预付款出票",
  purchaseBuyAcc: "买断账户出票",
  purchaseMonthlySett: "月结出票",
  fromDepartStation: "当前去程站点无班次",
  shouldBeLater: "返程日期必须大于去程日期",
  noReturnStation: "当前返程站点无班次",
  pleaseSelectFirstly: "请先选择去程座位",
  ticketmMsg: "返程车票不能多于去程车票",
  schedule: "班次",
  unabletomatch: "未能匹配到相应去程",
  allUnlocked: "解除所有锁位成功",
  modifyPriceSourceSuccess: "修改价格规则成功",
  modifyTicketTypeSuccess: "修改票种成功",
  areaCode: "请选择手机所属区号",
  pleaseFillTel: "请填写联系方式",
  purCompleted: "已成功下单",
  seatsOccupied: "已锁座",
  selectType: "选择类型",
  selectTicketCate: "选择票种",
  fillIn: "请输入",
  moreThanNum: "8 人以上",
  saveDdefault: "确认保存出发/到达城市、站点作为默认项？",
  saved: "保存成功",
  pleaseCity: "请选择城市后查询",
  countdown: "倒计时",
  showDepartCity: "选择出发城市后显示",
  showArriveCity: "选择到达城市后显示",
  remainingTickets: "余票",
  openTicket: "Open票",
  openTicketPrice: "原票价值",
  authorizedPrice: "当前班次未配置价格或没有销售权限",
  scheduleFirstly: "请先选择去程班次时间",
  later: "返程开车时间不可小于去程",
  ticketSales: "车票销售",
  purchase: "出票",
  chargeDetails: "收费明细",
  purchaseInformation: "购买信息",
  pay: "支付",
  total: "合计",
  supplementaryOrLuggage: "附加票/行李票",
  baggageTicket: "行李票",
  additionalTicket: "附加票",
  orderInfo: "订单信息",
  ticketTotalPrice: "车票总金额",
  baggagesTotalPrice: "行李票总金额",
  additionalsTotalPrice: "附加票总金额",
  couponTotalPrice: "现金券总金额",
  couponNumber: "现金券编号",
  addAdditionalTicketOrBaggageTicket: "添加附加票/行李票",
  success: "成功",
  ticketNumber: "车票号",
  serialNumber: "编号",
  discountAmount: "优惠金额",
  netPrice: "应收金额",
  collection: "收款",
  change: "找零",
  executePurchase: "执行销售",
  connectionFailed: "连接失败",
  printing: "打印即将开始",
  reminder: "提示",
  notBluetooth: "检测到尚未连接蓝牙打印机，请确认是否连接",
  connect: "去连接",
  noNeed: "不需要",
  complimentaryTickets: "赠票",
  confirmDel: "是否删除",
  delConfirm: "删除确认",
  delete: "删除",
  confirm: "确定",
  cancel: "取消",
  chineseID: "内地身份证",
  hongKongID: "香港身份证",
  macaoID: "澳门身份证",
  hkAndMacaoPermit: "港澳通行证",
  hkAndMacaoResidents: "港澳回乡证",
  taiwanResidents: "台湾通行证",
  chinesePassport: "内地护照",
  hkPassport: "香港护照",
  macaoPassport: "澳门护照",
  otherID: "其他证件",
  adult: "成人票",
  elder: "长者票",
  child: "小童票",
  baby: "婴孩票",
  student: "学生票",
  selected: "选中",
  sold: "已售",
  reserved: "预留",
  pleaseInTicket: "请先输入票段",
  pleaseInCash: "请先输入现金券",
  orderInquiry: "订单查询",
  orderNumber: "订单号",
  transactionType: "交易类型",
  productType: "产品类型",
  productSegmentation: "产品细分",
  characteristic: "特性",
  orderType: "订单类型",
  salesUnit: "销售单位",
  orderStatus: "订单状态",
  completed: "已完成",
  orderDate: "下单日期",
  to: "至",
  orderTime: "下单时间",
  orgStructure: "组织机构",
  transactionAmount: "交易金额",
  agentTranAmount: "代理交易金额",
  freeTickets: "赠票票段",
  totalDiscountAmount: "优惠总金额",
  handPurchaseOrder: "手写票销售订单",
  select: "请选择",
  productName: "产品名称",
  offerName: "优惠名称",
  transactionInfo: "交易信息",
  salesman: "销售员",
  PrepaymentAndMonthly: "预付款账户/月结账户支出",
  buyoutAccount: "买断账户",
  buyoutAccountPay: "买断账户支出",
  ticketInformation: "车票信息",
  reschedule: "改签",
  refund: "退票",
  ticketStatus: "车票状态",
  sendingMessage: "发送短信",
  sendTime: "发送时间",
  salesTime: "销售时间",
  selectShiftAndDisplay: "选择班次并显示",
  printerFailed: "打印机连接失败",
  refundInfo: "退款信息（代理对乘客）",
  rebookedTicketPriced: "改签车票按照原票和改签后票价的最高面额计算",
  refundFee: "退票手续费",
  refundAmount: "应退金额",
  amount: "金额",
  refundDetailamount: "退款明细（代理对冠忠）",
  ticketPreview: "车票预览",
  startPrinting: "开始打印",
  pleaseConnectPrinter: "请连接打印机",
  pleaseConnectBluetooth: "请连接蓝牙",
  bluetoothPrinter: "蓝牙打印机",
  IEPrinter: "IE打印",
  expiryDate: "使用有效期",
  groupTicketPrice: "票价(团体票)",
  includingTicketPrice: "票价（含附加票价）",
  passenger: "乘客",
  groupTicketAmount: "团体票人数",
  noSpecificSeat: "不按座位号乘车",
  groupTicket: "团体票",
  people: "人",
  oneWayOpenTicket: "单程open票",
  ticketNumberBinded: "绑定车票号",
  baggageTicketNumber: "行李票号",
  supplementalTicketNumber: "补价票号",
  supplementalTicketPrice: "补价票价",
  baggageTicketPrice: "行李票价",
  charteredTicketNumber: "包车票号",
  orderDealer: "下单人",
  onboardingAmount: "乘车人数",
  close: "关闭",
  refundTime: "退票时间",
  modifyPrintStatus: "修改打印状态",
  printStatus: "打印状态",
  qrCodeBoarding: "二维码乘车",
  pleaseSelectReason: "请选择原因",
  clear: "清空",
  rebooked: "已改签",
  refunding: "退款中",
  notReserved: "open票未取位",
  openReserved: "open票已取位",
  printerOfPaper: "打印机不出纸",
  printingMsg: "打印不清晰，车票作废",
  printingSystemMsg: "系统问题导致未成功打印",
  connectionMsg: "网络问题导致无法出票",
  other: "其他",
  cash: "现金",
  channelMsg: "现金、原支付渠道退回",
  ticketInquiry: "车票查询",
  associatedMsg: "关联往返车票号",
  passengerInfo: "乘客信息",
  scheduleNumber: "班次号",
  vehicleSize: "车型",
  drivingDate: "开车日期",
  generalAndSubAgent: "总代理+子代理",
  subAgentName1: "子代理名称（繁体）",
  pleaseEnterLoginID: "请输入员工账号",
  pleaseEnterPassword: "请输入密码",
  pleaseEnterIDeode: "请输入验证码",
  login: "登录",
  home: "首页",
  verifyCode: "校验码",
  checkMsg: "8-20位的字符，不可以纯数字",
  incorrectIdentifyingCode: "请输入正确的验证码",
  commitMsg: "提交信息有误，请按要求填写",
  pleaseLogInAgain: "请重新登录",
  quitConfirm: "退出确认",
  pleaseEnterOldPassword: "请输入旧密码",
  pleaseEnterNewPassword: "请输入新密码",
  pleaseEnterConfirmPassword: "请输入确认密码",
  passwordNotMatch: "密码输入不一致",
  modifySuccessReLogin: "修改成功，请重新登录",
  accountInfo: "账号信息",
  basicInfo: "基本信息",
  messageNotification: "消息通知",
  title: "标题",
  content: "内容",
  publishTime: "发布时间",
  modifyPassword: "修改密码",
  oldPassword: "旧密码",
  newPassword: "新密码",
  confirmPassword: "确认密码",
  submit: "提交",
  loginAccount: "账号",
  password: "密码",
  logout: "退出登录",
  afterQuitYouNeedToLogInAgain: "退出后需重新登录，请确认是否退出当前登录",
  Error404: "请求发生404错误",
  error500: "请求发生500错误",
  connectionTimedOut: "请求超时",
  networkError: "网络异常",
  requestFailed: "请求失败",
  pleaseConnectUSB: "请使用",
  charteredTicket: "包车票",
  oneDayUseOnly: "仅当天有效",
  HZMBridgeIsland: "港珠澳人工岛",
  ShatoujiaoExpress: "沙巴特快",
  hotline: "服务热线：",
  passengerCopy: "乘车联",
  reimbursementCopy: "报销联",
  intermodalityCopy: "转乘联",
  connectingCopy: "换乘联",
  stubCopy: "存根联",
  seatMsg: "不按座位乘车",
  rufundRebookNot: "不退不改",
  printingError: "打印错误，原因",
  transactions: "支付方式：",
  invalidCopy: "此联无效",
  route: "路线",
  onlyForEachTicket: "每票只限一件行李",
  retail: "门市",
  onlyForIE: "此功能仅支持IE浏览器，请切换到IE浏览器进行操作",
  systemError: "后台错误",
  returnOpenTicket: "返程open票",
  refundVoucher: "退票凭证",
  includeDisabledOrganization: "是否包含已停用组织",
  includeMore: "是否自动勾选上下级",
  canInputFilter: "可输入过滤",
  requestError: "请求错误",
  changeTicketType: "改变票种类型",
  returnTicketFetch: "返程取位",
  arrivalDate: "到达日期",
  closeRefundPrintDialog: "关闭退票打印弹窗",
  autoFillTicketNumber: "",
  purchaseDate: "购买日期",
  rechargeQuantity: "增值数量",
  availableQuantityMaster: "可用数量 （总代理）",
  availableQuantityTotal: "可用数量 （总代理+子代理）",
  availableQuantity: "可用数量",
  departurePriceArea: "出发价格区域",
  arrivalPriceArea: "到达价格区域",
  availableAmountAfterChange: "可用数量-变动后",
  buyoutNumber: "买断编号",
  showAfterSchedule: "选择班次后显示",
  designated: "指定",
  checked: "已验票",
  adult2: "成人",
  elder2: "长者",
  child2: "小童",
  baby2: "婴孩",
  student2: "学生票",
  ticketType: "票类",
  pleaseSelectTickets: "请勾选车票进行操作",
  onlyReturnOpen: "仅能同时选择返程",
  sameRoute: "请选相同线路车票操作",
  baggagesTotalPrice2: "行李票总金额",
  additionalsTotalPrice2: "附加票总金额",
  cashVoucherInvalid: "现金券，此联无效",
  printingException: "打印异常，原因",
  maxPassengers: "已达最大可选人数",
  confirmClosePopup: "确定关闭弹窗？",
  pleaseSelectStation: "请选择站点后再确定",
  pleaseSelectReturnSchedule: "请选择返程班次后再确定",
  noRoute: "该班次无路线",
  pleaseSelectSeat: "请选择座位后进行提交",
  websocketFailed: "WebSocket",
  noUSBDevice: "没有找到",
  tscPrinterNotConnected: "TSC",
  changeTrip: "改行程",
  onceSold: "一经销售",
  hkAndHZMBridge: "香港及港珠澳大桥段",
  seatNum2: "座号",
  destination: "目的地：",
  date: "时间：",
  boardingPoint: "上车点：",
  businessException: "业务异常",
  missingInputParameter: "入参缺失",
  systemException: "系统异常",
  invalidParameterType: "参数类型错误",
  requestBodyCannotBeEmpty: "请求体不可为空",
  invalidFieldType: "字段类型错误",
  aggResultCodeFile: "AggResultCode文件",
  cannotFindPriceForStop: "找不到站点所属价格",
  cannotOperateOutsideAgency: "不能操作非本代理体系下的订单车票",
  failedToObtainAgencyCredentials: "代理身份获取失败",
  pleaseSelectAgencySettlementMethod: "请选择代理结算方式",
  failedToPlaceOrderFromAgencyInventory: "代理库存下单失败",
  ticketSettlementTypeMismatch: "车票结算类型与当前接口账号所属不符",
  originalPaymentMethodInconsistent: "车票原支付方式不一致，请分开操作",
  noSalesPermissionForStop: "没有当前站点的销售权限",
  insufficientSalesPermissions: "销售权限不够",
  pleaseSelectDepartureScheduleDateTime: "请选择去程班次日期和时分",
  pleaseSelectReturnScheduleDateTime: "请选择返程班次日期和时分",
  jointRoutesCannotRescheduleAcrossLines: "粤港联营班次不能跨路线改签",
  ticketStandardPriceNotSet: "车票标准价未设置",
  productNotEligibleForReturn: "此商品不支持退货退款",
  pleaseEnterPassengerName: "请填写乘客姓名",
  pleaseEnterPassengerMobile: "请填写乘客手机号",
  pleaseEnterPassengerID: "请填写乘客证件号",
  pleaseEnterPassengerEmail: "请填写乘客email",
  tourProductTicketsCannotBeRefundedIndividually: "旅游产品车票不能单独退",
  outboundInfoCannotBeEmpty: "去程信息不能为空",
  returnInfoCannotBeEmpty: "返程信息不能为空",
  invalidOutboundInfoSelected: "去程信息选择错误",
  invalidReturnInfoSelected: "返程信息选择错误",
  productNotFound: "未找到产品",
  productExpired: "产品已失效",
  noTicketInfoUnderBundle: "未找到打包产品下的车票信息",
  routeNotFound: "路线不存在",
  pickupDateIncorrect: "取票日期有误",
  passengerNameEnglish38: "乘客姓名必须为英文并且小于38位字符",
  emailFormatOrLength: "邮箱格式错误或者超出20个字符限制",
  mobileFormatError: "手机号格式错误",
  usageDateExceedsValidity: "使用日期超出有效期",
  exchangeRateNotConfigured: "汇率未配置，请先配置汇率",
  agentCannotRefundTourProduct: "代理不可操作旅游产品退款",
  failedToReserveSeatsForPackage: "套票占座失败",
  incorrectRouteForPackage: "套票路线选择有误",
  incorrectUserTypeForTourProduct:
    "旅游产品所选分配用户类型错误，只能选择管理机构或代理",
  apiOrderResultCodeFile: "ApiOrderResultCode文件",
  orderException: "下单异常",
  authenticationResultCodeFile: "AuthenticationResultCode文件",
  missingApiAuthParams: "接口身份认证参数缺失",
  apiAuthFailed: "接口身份认证失败",
  apiAccountNotActivated: "接口账号未开通",
  failedToObtainApiUserInfo: "接口用户信息获取失败",
  apiRequestTimestampExpired: "接口请求时间戳过期",
  userNoAccess: "用户没有访问权限",
  consoleRespCodeFile: "ConsoleRespCode文件",
  supplierNotFound: "供应商不存在",
  financeRespCodeFile: "FinanceRespCode文件",
  depositSlipNotFound: "存款单不存在",
  settlementPriceMismatch: "结算价和柜台收款总额不一致",
  dataMismatchRefresh: "提交数据和系统数据不一致，请刷新后重试",
  crossCurrencyRepaymentNotSupported: "暂不支持跨币种还款",
  repaymentAmountMismatch: "还款金额和存款金额不一致",
  insufficientRepayableAmount: "剩余可还款额不足",
  repaymentMustNotExceedRemaining: "当前还款额需小于等于剩余可还款额",
  preApprovalFormNotFound: "预审单不存在",
  formsRespCodeFile: "FormsRespCode文件",
  statisticalRouteNotFound: "统计路线不存在",
  baseRouteNotFound: "基础路线不存在",
  lineRespCodeFile: "LineRespCode文件",
  insufficientRemainingTickets: "余票不足",
  reservedSeatsTimedOut: "所选占座已超时释放",
  itineraryInfoNotFound: "行程信息不存在",
  seatUnavailable: "座位不可用",
  failedToRevertOrderSeatLock: "订单锁座回退到普通占座失败",
  currentScheduleStatusUnavailable: "当前班次状态不可用",
  seatTemplateUpdated: "座位模板已更新，请重新选择",
  scheduleUnavailable: "班次因特殊情况，已改为不可售，请购买其他班次",
  prepaidAccount: "预付款账户",
  allocate: "分配",
  recover: "回收",
  transfer: "转移",
  agentId: "代理编号",
  agentNameSimplified: "代理名称（简体）",
  agentNameTraditional: "代理名称（繁体）",
  agentLevel: "代理级别",
  mainAgent: "总代理",
  viewDetails: "查看明细",
  totalPrincipal: "本金总额",
  totalAvailable: "可用总额",
  totalBonusRate: "总赠送率",
  totalDiscountRate: "总折扣率",
  appreciationRecords: "增值记录",
  operationTime: "操作时间",
  operator: "操作人",
  principalAppreciation: "本金增值",
  bonusRate: "赠送率",
  totalAppreciation: "增值总额",
  discountRate: "折扣率",
  changeRecords: "变动记录",
  changeType: "变动类型",
  totalAvailableBeforeChange: "可用总额-变动前",
  totalAvailableChange: "可用总额-变动",
  totalAvailableAfterChange: "可用总额-变动后",
  allocationRecords: "分配记录",
  subAgentId: "子代理编号",
  subAgentIdTraditional: "子代理编号（繁体）",
  subAgentIdEnglish: "子代理编号（英文）",
  totalAvailableAllocated: "可用总额-分配额",
  operationDate: "操作日期",
  subAgentName: "子代理名称",
  totalAvailableBeforeAllocation: "可用总额-分配前",
  totalAvailableAfterAllocation: "可用总额-分配后",
  recoveryRecords: "回收记录",
  totalAvailableBeforeRecovery: "可用总额-回收前",
  totalAvailableAfterRecovery: "可用总额-回收后",
  totalAvailableRecoveredAmount: "可用总额-回收额",
  transferRecords: "转移记录",
  transferIn: "转入",
  transferOut: "转出",
  totalAvailableTransferredAmount: "可用总额-转移额",
  transferringSubAgentName: "转出子代理名称",
  receivingSubAgentName: "转入子代理名称",
  transferringSubAgentId: "转出子代理编号",
  totalAvailableTransferOutAmount: "可用总额-转出额",
  receivingSubAgentId: "转入子代理编号",
  enterTicketInfoForQuery: "输入车票相关信息进行查询",
  paymentOrderType: "支付订单",
  refundOrderType: "退款订单",
  multiTypeOrderType: "多类型订单",
  fareSupplementOrder: "补价票订单",
  fareSupplementRefundOrder: "补价票退票订单",
  busTicketPurchaseOrder: "巴士购票订单",
  busRescheduleOrder: "巴士改签订单",
  busRefundOrder: "巴士退票订单",
  busModifySignOrder: "巴士扫描改签订单",
  busSeatBookingOrder: "巴士扫描取位订单",
  baggageTicketOrder: "行李票订单",
  groupTicketOrder: "团体票订单",
  freesTicket: "免费票",
  externalSystemOrder: "系统外订单",
  openTicketSalesOrder: "open票销售订单",
  openTicketSeatAssignmentOrder: "open票取位订单",
  agentInventoryOrder: "代理库存订单",
  inProgressStatus: "进行中",
  completedStatus: "已完成",
  cancelled: "已取消",
  toDate: "至",
  startDateSearch: "开始日期",
  endDateSearch: "结束日期",
  allOptions: "全部",
  timedOutStatus: "已超时",
  hourTimeUnit: "时",
  minuteTimeUnit: "分",
  advancedSearchButton: "高级",
  resetButton: "重置",
  enabledStatus: "启用",
  disabledStatus: "禁用",
  noDataFound: "无数据",
  conditionalSearch: "条件搜索",
  unitCode: "单位编号：",
  unitName: "单位名称：",
  operatingCompany: "运营公司：",
  search: "搜索",
  city: "城市",
  parentUnit: "上级单位",
  selectOption: "选择",
  selectStructure: "选择架构",
  deactivated: "已停用",
  selectAffiliatedUnitTitle: "选择所属单位",
  searchCriteriaEmptyError: "搜索条件不能为空",
  pleaseSelectManagementOrgMsg: "请选择管理机构",
  added: "已添加",
  managementOrgCode: "管理机构编号",
  managementOrgName: "管理机构名称",
  addSelectedUnits: "添加已勾选单位",
  unitAlreadyAddedError: "此单位已添加！",
  selectOnlyOneUnitMsg: "最多选择一个单位",
  notTraveledStatus: "未乘车",
  inTransitStatus: "乘车中",
  usedTicketStatus: "已使用",
  ticketRefundedStatus: "已退票",
  expiredStatus: "已过期",
  partiallyRefundedStatus: "部分已退款",
  noSeatAssignedStatus: "未取位",
  pendingSeatAssignmentTicketNumberLabel: "待取位车票号",
  clickToCopyToClipboardMsg: "点击可复制到剪切版",
  pleaseEnterOrderNumberOrDateMsg: "请输入订单号或者选择下单日期",
  ticketInquiryTitle: "车票查询",
  batchPrintAction: "批量打印",
  batchRefundAction: "批量退票",
  failedToObtainTicketNo: "获取ticketNo失败",
  pleaseSelectTicketMsg: "请选择车票",
  thisTicketLabel: "该车票",
  alreadyPrintedMsg: "已打印，请重新选择",
  pleaseSelectMultipleTickets: "请选择多项车票",
  ticketStatusNotSupportRefund: "选中车票状态不支持退票",
  jointOperationNoRefund: "合营车票不支持退票",
  ticketTypeOrStatusNoRefund: "选中车票类型或车票状态不支持退票",
  oneWayOrRoundTrip: "单程/往返",
  departureTimeHourMinute: "开车时分",
  departureStationManagement: "出发站点(管理)",
  arrivalStationManagement: "到达站点(管理)",
  ticketPrice: "票面价",
  agentPrice: "代理价",
  seatAssignmentAction: "取位",
  refundReasonLabel: "退票原因",
  refundConfirmationMsg: '点击"退票"后,即完成退票,退票后车票不可恢复',
  unlockAction: "解锁",
  unlockSuccessful: "解除锁定成功",
  refundMethodLabel: "退款方式",
  failedToObtainTicketNumber: "获取车票号失败",
  ticketDetailsLabel: "车票详情",
  seatReleaseAction: "消位",
  printRefundVoucherAction: "打印退票凭证",
  printTicketAction: "打印车票",
  printTicketShort: "印票",
  cashCouponNameLabel: "现金券名称",
  cashCouponDiscountLabel: "现金券优惠",
  salesPerson: "销售人员",
  pricingInformationLabel: "价格信息",
  transactionTime: "交易时间",
  orderLabel: "订单",
  QrCodeForBoarding: "二维码乘车",
  cashCouponLabel: "现金券",
  rescheduleOrSeatAssignment: "改签/取位",
  passengerReschedulingFee: "乘客改签手续费",
  noRefundForPassengerReschedule: "乘客改签不退回差额",
  noRefundForPassengerSeat: "乘客取位不退回差额",
  passengerRefundFee: "乘客退票手续费",
  agentReschedulingFee: "代理改签手续费",
  agentRefundFee: "代理退票手续费",
  agentRefundProcessingFee: "代理退票服务费",
  regionalDiscountLabel: "区域优惠",
  monthlyCommissionLabel: "月结佣金",
  promotionalDiscountLabel: "赠送优惠",
  settlementPriceLabel: "结算价",
  ticketItineraryInfo: "车票行程信息",
  numberLabel: "第",
  segmentLabel: "段行程",
  failedToObtainTicketId: "获取ticketId失败",
  modificationCompletedMsg: "修改完成",
  editReasonLabel: "修改原因",
  enterModificationReason: "请输入修改原因",
  seatCancellationReason: "消位原因",
  validityAfterCancellation: "消位后有效期：",
  confirmSeatCancellation: "确定消位",
  noSchedulesAtStation: "当前站点无班次",
  maxReschedulesReached: "已达到改签人数上限",
  pricingRuleModified: "修改价格规则成功",
  selectPhoneAreaCode: "请选择手机所属区号",
  reschedulingCompleted: "已成功改签",
  rescheduleOrderInfo: "改签订单信息",
  reschedulingFeeDetails: "改签费用信息",
  originalTicketNumber: "原票号",
  originalTicketPrice: "原票价",
  newTicketPrice: "新票价",
  ticketPriceDifference: "票价差额",
  reschedulingFee: "改签手续费",
  transactionTimeAndDate: "交易时间/交易日期",
  ticketCountUnit: "张",
  fullRefundRuleMsg: '此车票绑定了"原票+赠票整批退"规则，即将整批退票',
  routeNameLabel: "路线名称",
  refundAmountValue: "退款金额",
  reschedulePaymentAmount: "改签支付金额",
  yes: "是",
  no: "否",
  ticketValidationTimeLabel: "验票时间",
  expirationTimeLabel: "过期时间",
  refundTicketNumberLabel: "退票车票号",
  refundAmountLabel: "退回金额",
  managementOrg: "管理机构",
  mobileNumber: "手机号",
  refundInProgressStatus: "退票中...",
  personalLogin: "个人登录",
  orderQRCode: "订单二维码",
  coachMessage: "教练短信",
  userCenter: "个人中心",
  reportPreview: "报表预览",
  intelligentSearch: "智能搜索",
  businessAnalysis: "经营分析",
  userSystem: "用户体系",
  noPageAvailable: "暂无页面",
  assetManagement: "资产管理",
  ticketSalesInquiry: "查询售票",
  openTicketSales: "open票销售",
  seatAssignmentReservation: "取位留位",
  reservedTicketSales: "预留票销售",
  reservedOrderDetails: "预留订单详情",
  handwrittenTicketSales: "手写票销售",
  tourismProduct: "旅游产品",
  tourismProductSales: "旅游产品销售",
  tourismProductOrders: "旅游产品订单",
  tourismProductOrderDetails: "旅游产品订单详情",
  orderTicketManagement: "订单车票管理",
  orderDetails: "订单详情",
  ticketRescheduling: "车票改签",
  smsManagement: "短信管理",
  smsDetails: "短信详情",
  reportManagement: "报表管理",
  settlementReport: "结算报表",
  groupTicketReport: "团体票报表",
  soldByOperator: "操作员售出",
  refundRecords: "退票记录",
  agentRevenueReport: "代理营收报表",
  agentInventoryReport: "代理库存表",
  businessReport: "业务报表",
  universalReportSales: "万能报表销售",
  universalReportSeat: "万能报表取位",
  appreciationRecord: "充值记录表",
  balanceTransfer: "额度转移表",
  prepaidReport: "预付款报表",
  agentRemainingPrepaid: "代理剩余预付款",
  agentRemainingPrepaidSummary: "预付款剩余汇总",
  batchTrips: "为已勾选车票，批量选择返程时间",
  retrieveTrip: "为此车票选择返程时间",
  SelectPricingRule: "选择价格规则",
  selectOpenMsg: "仅能同时选择返程open车票操作",
  PleaseStation: "请选择站点后查询",
  viewReservation: "查看预留",
  addTicketSales: "补入售票",
  underVerification: "核查中",
  pleaseConfirm: "请确认",
  cancelOrder: "是否取消下单",
  pleasePay: "请让乘客支付",
  returnTimeEarlierThanDepartureTime: "返程时间小于去程时间，请重新安排班次",
  thisTicketIsBoundToTheRuleOf:
    "此车票绑定了“原票+赠票整批退”规则，即将整批退票",
  inReasonForModif: "请填写修改原因",
  agent: "代理",
  autoFillNumber: "自动填充票号",
  yuegangTicket: "粤港车票",
  groupTicket_maxThreeDigits: "最多3位整数",
  groupTicket_maxFiveTwo: "最多5位整数2位小数",
  groupTicket_amountGreaterThanZero: "付款金额需大于0",
  pleaseSelectTransferOutSubAgent: "请选择转出子代理",
  pleaseSelectTransferInSubAgent: "请选择转入子代理",
  recoveryAmountExceedsAvailable: "当前回收额超过可用总额，请重新输入",
  transferAmountExceedsAvailable: "当前转移额超过可用总额，请重新输入",
  pleaseSelectSubAgentToAllocation: "请选择子代理进行分配",
  pleaseSelectSubAgentToRecovery: "请选择子代理进行回收",
  pleaseSelectSubAgentToTransfer: "请选择子代理进行转移",
  allocationSuccess: "分配成功",
  recoverySuccess: "回收成功",
  transferSuccess: "转移成功",
  notPrinted: "未打印",
  Printed: "已打印",
  ticketNumberCopied: "车票号已复制并填充至搜索表中！",
  orderNumberCopied: "订单号已复制并填充至搜索表中！",
  clickToCopyOrderNumber: "点击复制订单号",
  passengerName: "乘客姓名",
  queryCondition: "请至少输入一个查询条件",
  pleaseInTicketNo: "请输入票号",
  //查询售票页面
  lineDepartTime: "班次始发时分",
  seatStatus: "座位状态",
  alightingPoint: "下站点",
  remarks: "备注",
  ticketNo: "票号",
  boarding: "上站",
  alighting: "下站",
  contactPerson: "联系人",
  contactNumber: "联系电话",
  operationType: "操作类型",
  departureStationPassengerCount: "出发站点人数统计",
  arrivalStationPassengerCount: "到达站点人数统计",
  departureCityArea: "出发城市/区域",
  destinationCityArea: "到达城市/区域",
  forenoon: "上午",
  afternoon: "下午",
  evening: "晚上",
  serialS: "序",
  availableS: "可",
  soldS: "售",
  reserveS: "留",
  totalS: "总",
  firstLinesoldreserve: "首段班次（已售/预留）",
  station: "站点",
  printTime: "打印时间",
  print: "打印",
  prePrint: "预打印",
  seatLog: "座位日志",
  status: "状态",
  edit: "编辑",
  //预留票销售 Booking Ticket list
  ticketCollectorName: "取票人姓名",
  ticketCollectorContactWay: "取票人联系方式",
  reservationOperator: "操作预留人员",
  reservationOperatTime: "操作预留时间",
  reservationTime: "预留时间",
  searchReservedTickets: "输入预留票相关信息进行查询",
  //预留票销售 Booking Ticket Details
  reserveDetails: "预留详情",
  cancelReserve: "取消预留",
  saleAction: "销售",
  reserveStore: "预留门市",
  busDepartureTime: "班次发车时间",
  operationLogs: "操作日志",
  operateDetail: "操作详情",
  confirmCancelReserve: "确认取消预留座位？",
  confirmExecuteSale: "确认执行销售？",
  lineCode: "班次代码",
  partialSaleConfirm: "不可销售，仍销售可售部分？",
  allReservedNotSalable: "预留座位均不可售",
  // 手写票销售页面
  netAmount: "应收总金额",
  ticketSuccessMsg: "出票成功！",
  add2: "添加",
  fillInTicketSection: "请输入赠票票段",
  issueTicket: "出票",
  handwrittenTicket: "手写票",
  freeTicket: "自由票",
  // 旅游票确认表格新增字段
  // API旅游产品销售 API Product Pack Sale
  APIProductSale: "API旅游产品销售",
  fusionTab: "融创API门票/套票",
  disneyTab: "迪士尼API门票/套票",
  chimelongTab: "长隆API门票/套票",
  tourTab: "自有产品单售/套票",
  hotelTab: "酒店产品套票",
  huafaTab: "华发API门票/套票",
  westkTab: "西九文化区门票/套票",
  passengerInfoIncomplete: "第{n}位乘客信息填写不完整！",
  certNoDuplicate: "乘客证件号码不能重复！",
  estimatedTotal: "销售价合计",
  fillCompleteInfo: "下单信息填写完整!",
  fillCompleteCert: "证件信息填写完整!",
  nameEnglishOnly: "姓名只能是英文!",
  fillCompleteInfoAndName: "下单信息填写完整或姓名只能是英文!",
  selectAtLeastOne: "产品至少选购一样!",
  session: "场次",
  price: "价格",
  quantity: "数量",
  inputPlaceholder: "--",
  cardNumberInput: "请输入卡号",
  cardNumberInputLong: "请输入卡号,多个用英文逗号隔开",
  returnDepartureTime: "上车时间(返程)",
  productInfo: "产品信息",
  commodityInfo: "商品信息",
  commodityName: "商品名称",
  commodityNo: "商品编号",
  commodityOrderNo: "商品订单号",
  pleaseSelectCommodity: "请选择商品!",
  product: "产品",
  email: "邮箱",
  ticketInfo: "门票信息",
  packageTicketCount: "套票张数",
  remarksTraditional: "备注(繁)",
  outboundBoardingPoint: "去程上站点",
  outboundAlightingPoint: "去程下站点",
  outboundDepartureDate: "去程日期",
  outboundDepartureTime: "上车时间(去程)",
  returnBoardingPoint: "返程上站点",
  returnAlightingPoint: "返程下站点",
  returnDepartureDate: "返程日期",
  cardNo: "卡号",
  travelerInfo: "出行人信息",
  selectPOS: "POS机选择",
  pleaseSelectPOS: "请选择PSO机",
  selectProduct: "选择产品",
  pleaseSelectProduct: "请选择产品!",
  pickupWay: "领取方式",
  activityName: "活动名称",
  clickProductToChoose: "未选择产品或无ID无法出票,请点击产品名称选择",
  // 乘客信息录入
  seatLocked: "已锁位",
  seatNumReturn: "座位号（返程）",
  pleaseEnterName: "请输入姓名",
  pleaseEnterCardNo: "请填写卡号",
  checkCardNo: "卡号数量与购买数量不一致，请检查",
  browserVersionLow: "浏览器版本低",
  browserVersionLowPleaseUpdate:
    "您的浏览器版本太低，不支持浏览器串口的使用，请切换到最新版本浏览器",
  packageTicket: "套票",
  orderId: "订单ID",
  productNo: "产品编号",
  outboundReturn: "去程/返程",
  totalAmount: "合计金额",
  // 旅游产品订单详情
  ticket: "门票",
  busTicket: "车票",
  receipt: "收据",
  consultationPhone: "咨询电话",
  phoneNumbers: "（香港）29798778 （内地） 4008822322",
  download: "下载",
  salesChannel: "销售渠道",
  orderNumberAndSupplierOrderNo: "订单号/供应商订单号",
  supplierOrderNo: "供应商订单号",
  isPackage: "是否套票",
  packageName: "套票名称",
  sourceOrderNo: "销售订单号",
  printContent: "打印内容",
  transactionNo: "交易流水号",
  transactionMethod: "交易方式",
  productCategory: "产品类别",
  supplierName: "供应商",
  cityName: "所属城市",
  validType: "有效期类型",
  effectiveDeadline: "有效截止日期",
  productStatus: "商品状态",
  costPrice: "成本价",
  productPrice: "商品价格",
  sourceChannel: "渠道",
  validDays: "有效天数",
  refundable: "可退票",
  modifySupplierOrderNo: "修改供应商订单号",
  failedToGetOrderNo: "获取订单号失败",
  receiptGeneratingPleaseWait: "收据生成中,请稍后再试",
  generatingFailed: "收据生成失败",
  noPrintableTicket: "没有可打印的门票",
  tourPackageProductOrder: "Tour Package Product Order",
  transactionDate: "交易日期",
  baggageTicketDetails: "行李票详情",
  baggageTicketInfo: "行李票信息",
  BindTicketStatus: "绑定车票状态",
  getBaggageTicketFailed: "获取行李票号失败",
  back: "返回",
  organization: "机构",
  sendeAccount: "发送账号",
  user: "用户",
  userMobileNumber: "用户手机",
  userEmail: "用户邮箱",
  sendContent: "发送内容",
  addSms: "新增短信",
  missingRequiredParams: "缺少必要的参数",
  enterSMSInfoForQuery: "输入短信相关信息进行查询",
  enterOrderInfoForQuery: "输入订单相关信息进行查询",
  enterBaggageTicketInfoForQuery: "输入行李票相关信息进行查询",
  smsSentSuccessfully: "短信已发送成功",
  emailSentSuccessfully: "邮件已发送成功",
  resendSms: "重发短信",
  resendEmail: "重发邮件",
  //扫描车票页面
  sheet: "张票",
  adultTicket: "成人票",
  seat: "座位",
  boardingLocation: "上车地点",
  alightingLocation: "下车地点",
  address: "地址",
  intermediateBoardingLocation: "中途上车地点",
  serviceProvider: "服务供应商",
  noValidTicketsFound: "我们没有找到订单内有效的车票",
  ticketTipsTtem1:
    "为了乘车顺利，请提前15分钟到站等车，如有问题请联系站点工作人员",
  ticketTipsTtem2: "为了避免人员聚集，深圳湾口岸至香港班次先到先乘车",
  seoIndexKeywords: "環島中港通 香港 車票",
  failedToObtainTicketInfo: "获取车票信息失败",
  //打印预览页面
  loading: "加载中",
  printPreview: "打印预览",
  disneyTicketPreview: "迪士尼门票预览",
  disneyPackagePreview: "迪士尼套票预览",
  chimelongTicketPreview: "长隆门票预览",
  chimelongPackagePreview: "长隆套票预览",
  fusionTicketPreview: "融创门票预览",
  fusionPackagePreview: "融创套票预览",
  freeProductPackagePreview: "自由产品套票预览",
  hotelPackagePreview: "酒店套票预览",
  huafaTicketPreview: "华发门票预览",
  huafaPackagePreview: "华发套票预览",
  selfowndProductSingleTicketPreview: "自有产品单票预览",
  //旅游产品打印&确认
  orderCancelled: "订单已取消",
  orderCancelFailed: "订单取消失败",
  bookDate: "预定日期",
  ticketTypeL: "门票类型",
  validityPeriod: "有效期",
  departureTime: "出发时间",
  parentManagementOrg: "上级管理机构",
  pleaseSelectSchedule: "请选中班次后操作",
  pleaseReselectCity: "请重新选择城市，无法选择，未拥有的城市",
  refundF: "退款",
  refundSuccessful: "退款成功",
  refundReason: "退款原因",
  pleaseEnterRefundReason: "请输入退款原因",
  reservation: "预留",
  reserve2hours: "预留2小时",
  reserved12hours: "预留12小时",
  reserveduntil24hBefore: "预留至发车前24小时",
  reservedNoLimit: "不限时预留",
  pleaseEnterIdNo: "请输入证件号码",
  retrieveCardCode: "取卡串码",
  querying: "获取中",
  startPrint: "开始打票",
  totalRefundAmount: "总退票票面价",
  totalRefundSettleAmount: "总退票结算价",
  settleUnitName: "归属单位",
  saleAccountName: "归属工号",
  pleaseEnterRefundNote: "请输入退票备注",
  pleaseWaitForTerminalTransaction: "请等待终端交易唤起完成后再取消订单",
  pleaseCompleteBaggageTicketInfo: "请先完善行李票出票信息",
  placingOrder: "下单中",
  baggageOrSupplementTicketDetail: "行李票/补价票详情",
  baggageOrSupplementTicketInfo: "行李票/补价票信息",
  baggageOrSupplementTicketRefund: "行李票/补价票退票",
  baggageOrSupplementTicketQuery: "行李票/补价票查询",
  supplementTicketSales: "售补价票",
  refundTicket: "后台退票",
  refundNote: "退票备注",
  departureStation: "出发站点",
  arrivalStation: "到达站点",
  supplementTicket: "补价票",
  supplementBaggageTicket: "补行李票",
  itinerary: "行程",
  supplementPrice: "补价金额",
  seatAssignmentSuccess: "取位成功",
  // 打印ts文件
  transactionVoucher: "交易凭证",
  booker: "预定人",
  actualCollection: "实收款",
  hotelCity: "酒店城市",
  hotelName: "酒店名称",
  hotelAddress: "酒店地址",
  noRefundsForReschedule: "改签不退回",
  zhuhaiPort: "珠海口岸",
  macauSectionFree: "澳门段免费",
  travelDate: "乘车日期",
  refundFare: "退回票款",
  refundPaymentMethod: "退票支付方式",
  modifySuccess: "修改成功",
  plsDownloadWithAndroid: "请使用安卓手机下载",
  scheduleNotChoosed: "未选中班次",
  failedToGetDllData: "获取dll数据失败",
  tscPrinter: "台式打印机",
  hotelPersonNums: "入住人数",
  confirmEmptyQueryCondition: "确认清空所有查询条件么？",
  currentDepartureJourney: "当前去程",
  confirmFetchBtn: "确认取位",
  selectOpenMsg2: "仅能同时选择返程open车票操作",
  deleteAll: "全部删除",
  view_ticket_prices: "查看票价",
  faceValue: "票面价",
  discount: "优惠",
  // 收据相关翻译
  receiptTitle: "环岛中港通跨境巴士收据",
  reimbursementNote: "可用于报销",
  ticketTypeReceipt: "票种",
  ticketCategoryReceipt: "类型",
  hkPhone: "（香港）29798778",
  mainlandPhone: "（内地）4008822322",
  ticketNumberReceipt: "车票号",
  passengerNameReceipt: "乘客姓名",
  departureStationReceipt: "出发站",
  arrivalStationReceipt: "到达站",
  departureTimeReceipt: "发车时间",
  validDate: "有效日期",
  seatNumberReceipt: "座位号",
  ticketPriceReceipt: "票价",
  serviceProviderReceipt: "服务供应商",
  consultationPhoneReceipt: "咨询电话",
  openBusExpireTime: "乘车有效期",
  orderNo: "订单号",
  useDate: "使用日期",
  guest: "客人",
  prepaymentFlow: "预付款流水",
  changeAmount: "变动金额",
  outAccount: "转出账户",
  toAccount: "转入账户",
  seatHoldStats: "取位留位人数统计",
  tourProductDetail: "旅游产品详情",
  hk: "香港",
  cn: "內地",
  mo: "澳門",
  transferStationNotice: "注意：订单信息中一程是长途票，一程是口岸票！",
};
